import request from "@/views/setting/my-practice/service/request.js"
import requestV1 from "@/views/setting/my-practice/service/requestV1.js"

export function getSettingData(url) {
  return request({
    url: url,
    method: "get",
  });
}

export function changeSetting(url, data) {
  return request({
    url: url,
    method: "post",
    data
  })
}

export function getFirstCustomerOfCLInic(params) {
  return request({
    url: "/utility/getFirstCustomerOfClinic",
    method: "get",
    params
  });
}

export function checkCustomerOnboardingQuestionnaireStatus(params) {
  return request({
    url: "/utility/checkCustomerOnboardingQuestionnaireStatus",
    method: "get",
    params
  });
}

export function updateCustomerOnboardingQuestionnaire(data) {
  return request({
    url: "/trans/updateCustomerOnboardingQuestionnaire",
    method: "post",
    data
  });
}

export function updateSettingFromQuestionnaire(data) {
  return request({
    url: "/trans/updateSettingFromQuestionnaire",
    method: "post",
    data
  });
}

export function getReportPreferSettingData(url) {
  return requestV1({
    url: url,
    method: "get",
  });
}

export function changeReportPreferSetting(url, data) {
  return requestV1({
    url: url,
    method: "post",
    data
  });
}

export function getGeoByAddress(params) {
  return requestV1({
    url: "/setting/geoSearch",
    method: "get",
    params
  });
}

export function searchByGeo(data) {
  return requestV1({
    url: "setting/locationsByCoordinate",
    method: "post",
    data
  })
}

export function searchByName(data) {
  return requestV1({
    url: "setting/locationsByName",
    method: "post",
    data
  })
}

export function getClinicLogoSetting() {
  return request({
    url: "/setting/getClinicLogoSetting",
    method: "get",
  });
}

export function getSettingDataV1(url) {
  return requestV1({
    url: url,
    method: "get",
  });
}

// RBAC roles the signed-in user holds in the current clinic.
export function getClinicRoles() {
  return request({
    url: "/role/clinic-roles",
    method: "get",
  });
}

export function changeSettingV1(url, data) {
  return requestV1({
    url: url,
    method: "post",
    data
  });
}
